import { Title } from '~components/Typography';
import { UnsubscriptionFlowStages } from '~features/annals';
import { annals } from '~features/annals/hooks';
import { useTranslations } from '~i18n/hooks';
import { ReviewModal } from '~shared/ui/modals';
import { ButtonPrimary } from '~shared/ui/molecules/Buttons/ButtonPrimary';
import { ButtonSecondary } from '~shared/ui/molecules/Buttons/ButtonSecondary';

import { Features } from '../Features';
import { Policies } from '../Policies';
import { Row } from '../Row';

type Props = {
	onClose: () => void;
	onFeedback: () => void;
	onCancel: () => void;
	endDate: string;
};

export const MainModal = ({
	onClose,
	onFeedback,
	onCancel,
	endDate,
}: Props) => {
	const t = useTranslations('MySubscriptions');

	const trackButtonShareFeedback =
		annals.subscription.useClickButtonShareFeedback();
	const trackButtonCancelRenewal =
		annals.subscription.useClickButtonCancelRenewalFirst();
	const trackCloseModal = annals.subscription.useClickElementCloseCancelSub(
		UnsubscriptionFlowStages.PremiumActive
	);

	return (
		<ReviewModal
			open={true}
			onClose={() => {
				trackCloseModal();
				onClose();
			}}
			title={
				<Title size="M" align="left">
					{t('mainTitle')}
				</Title>
			}
			subtitle={t('mainSubtitle', { date: endDate })}
			data-name="my-subscriptions-modal"
		>
			<Features />
			<Row>
				<ButtonPrimary
					size="M"
					onClick={() => {
						onFeedback();
						trackButtonShareFeedback();
					}}
					fullWidth
				>
					{t('feedbackButton')}
				</ButtonPrimary>
				<ButtonSecondary
					size="M"
					onClick={() => {
						onCancel();
						trackButtonCancelRenewal();
					}}
					fullWidth
				>
					{t('cancelSubscriptionButton')}
				</ButtonSecondary>
			</Row>
			<Policies screen={UnsubscriptionFlowStages.PremiumActive} />
		</ReviewModal>
	);
};
